import { Section } from "@/components/ds/Section/Section";
import { Container } from "@/components/ds/Container/Container";
import { Stack } from "@/components/ds/Stack/Stack";
import { Heading } from "@/components/ds/Heading/Heading";
import { Text } from "@/components/ds/Text/Text";
import { SignupForm } from "@/components/forms/SignupForm";
import styles from "./FinalCTA.module.css";

export function FinalCTA() {
  return (
    <Section background="ink" id="get-started">
      <Container>
        <Stack gap={6} align="center" className={styles.wrapper}>
          <Heading level={2} size="h2" color="on-dark">
            You&apos;re ten minutes from a live rota.
          </Heading>
          <Text size="lg" color="on-dark-muted" className={styles.subtitle}>
            Sign up, add your first site, invite your first cleaner. Your
            first rota can be live before your next coffee. Free for 14 days,
            no card, no app install for your cleaners.
          </Text>
          <SignupForm dark ctaLabel="Get my first rota live" />
        </Stack>
      </Container>
    </Section>
  );
}
